import POICategoryApi from '@/api/POICategory'
import { POICategoryFormModel } from '@/models/POI/POICategoryForm'
import { POISubcategoryFormModel } from '@/models/POI/POISubcategoryForm'
import { POISubcategoryValueFormModel } from '@/models/POI/POISubcategoryValueForm'

export class POICategoryRepository {
  static async getCategory() {
    const res = await POICategoryApi.getCategory()
    return res.items.map(item => POICategoryFormModel.assign(item))
  }
  static async getSubcategory(poiCategoryId) {
    const res = await POICategoryApi.getSubcategory(poiCategoryId)
    return res.items.map(item => POISubcategoryFormModel.assign(item))
  }
  static async getSubcategoryValues(poiCategoryId, poiSubategoryId) {
    const res = await POICategoryApi.getSubcategoryValues(
      poiCategoryId,
      poiSubategoryId,
    )
    return res.items.map(item => POISubcategoryValueFormModel.assign(item))
  }
}
